export enum AgentFnMapKey {
  Load = 'load',
  Play = 'play',
  Pause = 'pause',
  Complete = 'complete',
  Seek = 'seek',
  Seeked = 'seeked',
}

enum AgentFnMap {
  load = 'notifyLoaded',
  play = 'notifyPlay',
  pause = 'notifyIdle',
  complete = 'notifyIdle',
  seek = 'notifyIdle',

  // Contrary to Sensic V2's documentation for JWPlayer,
  // https://drive.google.com/file/d/1IfoqMFKamAcDwbbiK7Qf5XMBoLSGDd23/view?usp=sharing (Section 2.1.3)
  // a playback may not always happen after `seeked` event.
  //
  // JWPlayer 8 will always fire `play` event if an actual playback happen. Therefore, it is more
  // accurate to solely listen to `play` event for `notifyPlay`
  seeked = 'notifyIdle',
};

export default AgentFnMap;
